"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _images = _interopRequireDefault(require("../common_features/assets/images"));
var _Services = require("../common_features/utility/Services");
var _AddNotes = _interopRequireDefault(require("../components/AddNotes"));
var _helper = require("../common_features/utility/helper");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AddNotesContainer = () => {
  var _location$state, _location$state2, _location$state$servi, _location$state3, _location$state$chang, _location$state4, _location$state$navHe, _location$state5, _location$state$succe, _location$state6, _location$state$succe2, _location$state7, _location$state$notes, _location$state8, _location$state$isFro, _location$state9;
  const location = (0, _reactRouterDom.useLocation)();
  let filterData = {};
  const payloadData = location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.payload;
  const fromScreen = location === null || location === void 0 ? void 0 : (_location$state2 = location.state) === null || _location$state2 === void 0 ? void 0 : _location$state2.fromScreen;
  const serviceLogType = (_location$state$servi = location === null || location === void 0 ? void 0 : (_location$state3 = location.state) === null || _location$state3 === void 0 ? void 0 : _location$state3.serviceLogType) !== null && _location$state$servi !== void 0 ? _location$state$servi : 2;
  const changesFlag = (_location$state$chang = location === null || location === void 0 ? void 0 : (_location$state4 = location.state) === null || _location$state4 === void 0 ? void 0 : _location$state4.changesFlag) !== null && _location$state$chang !== void 0 ? _location$state$chang : true;
  const navHeading = (_location$state$navHe = location === null || location === void 0 ? void 0 : (_location$state5 = location.state) === null || _location$state5 === void 0 ? void 0 : _location$state5.navHeading) !== null && _location$state$navHe !== void 0 ? _location$state$navHe : 'Edit System';
  const successModalTitle = (_location$state$succe = location === null || location === void 0 ? void 0 : (_location$state6 = location.state) === null || _location$state6 === void 0 ? void 0 : _location$state6.successModalTitle) !== null && _location$state$succe !== void 0 ? _location$state$succe : null;
  const successModalDetail = (_location$state$succe2 = location === null || location === void 0 ? void 0 : (_location$state7 = location.state) === null || _location$state7 === void 0 ? void 0 : _location$state7.successModalDetail) !== null && _location$state$succe2 !== void 0 ? _location$state$succe2 : null;
  const notes = (_location$state$notes = location === null || location === void 0 ? void 0 : (_location$state8 = location.state) === null || _location$state8 === void 0 ? void 0 : _location$state8.notes) !== null && _location$state$notes !== void 0 ? _location$state$notes : "";
  const [warningModal, setWarningModal] = (0, _react.useState)(false);
  const [isUpdating, setIsUpdating] = (0, _react.useState)(false);
  const [showModal, setShowModal] = (0, _react.useState)(false);
  const [isFromWaterInfo, setIsFromWaterInfo] = (0, _react.useState)((_location$state$isFro = location === null || location === void 0 ? void 0 : (_location$state9 = location.state) === null || _location$state9 === void 0 ? void 0 : _location$state9.isFromWaterInfo) !== null && _location$state$isFro !== void 0 ? _location$state$isFro : false);
  const [oldNote, setOldNotes] = (0, _react.useState)(notes);
  const [errorModalData, setErrorModalData] = (0, _react.useState)({
    ErrorModalHeaderText: "Oops!",
    ErrorModalDetailText: "The system could not update, please try again."
  });
  const [failureAction, setFailureAction] = (0, _react.useState)(0);
  const [notesText, setNotesText] = (0, _react.useState)(notes);
  const [charCount, setCharCount] = (0, _react.useState)('250');
  const navigate = (0, _reactRouterDom.useNavigate)();
  const {
    selectedSystems
  } = (0, _reactRedux.useSelector)(state => state.systems);
  if (fromScreen === 'editFilter' || fromScreen === 'editAccessory') {
    filterData = {
      systemId: selectedSystems.systemId,
      orgId: selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.orgId,
      ...(payloadData, {
        systemReferences: [{
          ...payloadData.systemReferences[0],
          ServiceLogNote: !notesText ? {} : {
            note: notesText
          }
        }]
      })
    };
  }
  if (fromScreen === 'addAccessory') {
    var _payloadData$systemDa;
    filterData = {
      orgId: selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.orgId,
      storeId: selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.storeId,
      systemAccessoryRecords: payloadData === null || payloadData === void 0 ? void 0 : (_payloadData$systemDa = payloadData.systemData) === null || _payloadData$systemDa === void 0 ? void 0 : _payloadData$systemDa.systemAccessoryRecords,
      ServiceLogImageUrls: payloadData.ServiceLogImageUrls,
      ServiceLogNote: !notesText ? {} : {
        note: notesText
      }
    };
  }
  const warningModalData = {
    variant: "warning-modal",
    displayModal: warningModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalHeaderText: errorModalData.ErrorModalHeaderText,
    modalHeaderTextStyle: {
      color: "#E00932"
    },
    modalDetailText: errorModalData.ErrorModalDetailText,
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: failureAction ? "Continue" : "Retry",
    negativeButtonActionTitle: "Cancel",
    positiveAction: () => handleFailureContinue(),
    negativeAvtion: () => handlefailureCancel()
  };
  const successData = {
    variant: "password-change-modal",
    displayModal: showModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalHeaderText: successModalTitle ? successModalTitle : "System Updated",
    modalHeaderTextStyle: {
      color: "#4F8309",
      fontfamily: "Poppins",
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: "22px"
    },
    modalDetailText: successModalDetail ? successModalDetail : "The system has been updated Successfully.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px",
      font: "Poppins"
    },
    positiveActionButtonTitle: "Continue",
    negativeActionButtonTitle: null,
    positiveAction: () => handleSucessModal()
  };
  (0, _react.useEffect)(() => {
    var _location$state10;
    //if user comes after 24 hours then no API call & notes empty
    if (fromScreen === "addAccessory" || isFromWaterInfo || (0, _helper.isTimeDifference24Hours)(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.createdAt, new Date().toISOString())) return;
    setIsUpdating(true);
    let refAppId = location === null || location === void 0 ? void 0 : (_location$state10 = location.state) === null || _location$state10 === void 0 ? void 0 : _location$state10.refAppId;
    (0, _Services.getLastServiceRecordByType)(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemId, serviceLogType, refAppId).then(data => {
      var _data$data$ServiceLog, _data$data, _data$data$ServiceLog2, _data$data$ServiceLog3;
      const notes = (_data$data$ServiceLog = data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : (_data$data$ServiceLog2 = _data$data.ServiceLogNotes) === null || _data$data$ServiceLog2 === void 0 ? void 0 : (_data$data$ServiceLog3 = _data$data$ServiceLog2[0]) === null || _data$data$ServiceLog3 === void 0 ? void 0 : _data$data$ServiceLog3.note) !== null && _data$data$ServiceLog !== void 0 ? _data$data$ServiceLog : "";
      if (!changesFlag) setNotesText(notes);
      setOldNotes(notes);
      setIsUpdating(false);
    }).catch(e => {
      setIsUpdating(false);
    });
    setIsUpdating(false);
  }, []);
  const handleSucessModal = () => {
    navigate(_RoutePath.default.systemDetail.useLink);
  };
  const handleFailureContinue = () => {
    if (!failureAction) {
      handleUpdateSystem();
    } else {
      handleCancel();
    }
    setWarningModal(false);
  };
  const handlefailureCancel = () => {
    if (!failureAction) {
      navigate(-2);
    } else {
      setErrorModalData({
        ErrorModalHeaderText: "Oops!.",
        ErrorModalDetailText: "The system could not update, please try again."
      });
      setFailureAction(0);
      setWarningModal(false);
    }
  };
  const handleBack = () => {
    navigate(-1);
  };
  const handleCancel = () => {
    navigate(_RoutePath.default.systemDetail.useLink);
  };
  const isButtonDisabled = () => {
    if (oldNote === notesText && !changesFlag) {
      return true;
    }
    return false;
  };
  const onChangeNotes = event => {
    setNotesText(event.target.value);
    setCharCount(250 - event.target.value.length);
  };
  const handleUpdateSystem = async () => {
    let systemData = {
      systemId: selectedSystems.systemId,
      orgId: selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.orgId,
      ServiceLogNote: {
        note: notesText
      },
      ...(!notesText && {
        ServiceLogNote: {}
      }),
      ...payloadData
    };
    setIsUpdating(true);
    const apiData = fromScreen === 'editFilter' || fromScreen === 'editAccessory' || fromScreen === 'addAccessory' ? filterData : systemData;
    if (fromScreen === 'addAccessory') {
      let systemId = selectedSystems.systemId;
      await (0, _Services.addAccessory)({
        ...apiData
      }, systemId).then(apiResp => {
        var _apiResp$response;
        if (((_apiResp$response = apiResp.response) === null || _apiResp$response === void 0 ? void 0 : _apiResp$response.status) === 404) {
          setErrorModalData({
            ErrorModalHeaderText: "Something went wrong",
            ErrorModalDetailText: "Please click on continue to refresh your page."
          });
          setFailureAction(1);
          setIsUpdating(false);
          setWarningModal(true);
        } else {
          setShowModal(true);
          setIsUpdating(false);
        }
      }).catch(error => {
        setIsUpdating(false);
        setWarningModal(true);
      });
    } else {
      await (0, _Services.updateSystem)({
        ...apiData
      }).then(apiResp => {
        var _apiResp$response2;
        if (((_apiResp$response2 = apiResp.response) === null || _apiResp$response2 === void 0 ? void 0 : _apiResp$response2.status) === 404) {
          setErrorModalData({
            ErrorModalHeaderText: "System has been deleted.",
            ErrorModalDetailText: "Please click on continue to refresh your page."
          });
          setFailureAction(1);
          setIsUpdating(false);
          setWarningModal(true);
        } else {
          setShowModal(true);
          setIsUpdating(false);
        }
      }).catch(error => {
        setIsUpdating(false);
        setWarningModal(true);
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement(_AddNotes.default, {
    isUpdating: isUpdating,
    showSteps: false,
    navHeading: navHeading,
    onBackPress: handleBack,
    onClickCancel: handleCancel,
    leftArrow: _images.default.leftArrow.default,
    cancelText: 'Cancel',
    subNotesText: charCount == 250 ? "Maximum character limit : 250" : "You have ".concat(charCount, " characters remaining"),
    headerText: 'Add Notes',
    notesText: notesText,
    subText: (selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemPartNumber) + " " + (selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemModelNumber),
    addNotesHeader: 'Add Notes',
    onChangeNotes: onChangeNotes,
    saveText: 'Submit',
    isButtonDisabled: isButtonDisabled(),
    onClickSave: handleUpdateSystem,
    successModalBtnTitle: "Continue",
    showUpdateErrorModal: warningModal,
    saveErrorModalData: warningModalData,
    showUpdateSuccessModal: showModal,
    successModalData: successData
  });
};
var _default = exports.default = AddNotesContainer;